import React, { useEffect, useState } from "react";
import ModalComponent from "common/components/Model";
import MDBox from "common/components/MDBox";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import MDButton from "common/components/MDButton";
import CommonSelect from "common/components/CustomSelect";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { saveLeaves } from "services/leaves/leaves";
import { getLeaves } from "services/leaves/leaves";

const Toast = Swal.mixin({
    toast: true,
    position: "top",
    zIndex: 10,
    showConfirmButton: false,
    timer: 2000,
    onOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
});

const reasonOptions = [
    { label: "Sick", value: "sick" },
    { label: "Vacation", value: "vacation" },
    { label: "Personal", value: "personal" },
    { label: "Other", value: "other" },
];

const typeOptions = [
    { label: "Annual", value: "annual" },
    { label: "Casual", value: "casual" },
    { label: "Non Payed", value: "non_payed" },
];

const EmployeeLeaveModel = ({ showModal, setShowModal, empId }) => {

    const dispatch = useDispatch();
    const [startDate, setStartDate] = useState("");
    const [noOfDays, setNoOfDays] = useState("");
    const [reason, setReason] = useState("");
    const [leaveType, setLeaveType] = useState("");
    const [saveLoader, setSaveLoader] = useState(false);
    const [leaveSummary, setLeaveSummary] = useState([
        {label: 'Annual', count: 0},
        {label: 'Casual', count: 0},
        {label: 'Non Payed', count: 0}
    ]);
    const [leaveData, setLeaveData] = useState([]);

    const saveLeavesSlice = useSelector((state) => state.saveLeavesSlice.leaves);
    const getLeavesSlice = useSelector((state) => state.getLeavesSlice.leaves);

    useEffect(() => {
        dispatch(getLeaves(empId))
    }, [])

    useEffect(() => {
        if (getLeavesSlice.isSuccess) {
            const leadeData = getLeavesSlice.data?.data
            setLeaveData(leadeData?.leaves)
            const counts = [
                {label: 'Annual', count: leadeData?.counts?.annual},
                {label: 'Casual', count: leadeData?.counts?.casual},
                {label: 'Non Payed', count: leadeData?.counts?.non_payed}
            ];
            setLeaveSummary(counts)
        }
    }, [getLeavesSlice.data])

    const clearForm = () => {
        setStartDate("");
        setNoOfDays("");
        setReason("");
        setLeaveType("");
    };

    const handleSubmit = () => {
        const payload = {
            emp_id: empId,
            start_date: startDate,
            no_of_days: parseInt(noOfDays),
            reason: reason,
            type: leaveType,
        };
        setSaveLoader(true);
        dispatch(saveLeaves(payload))
    };

    useEffect(() => {
        if (saveLoader) {
            if (!saveLeavesSlice.isLoading && saveLeavesSlice.isSuccess) {
                setSaveLoader(false);
                clearForm();
                dispatch(getLeaves(empId))
                Toast.fire({
                    icon: "success",
                    title: "Leave Added Successfully",
                });
            } else if (saveLeavesSlice.isError) {
                setSaveLoader(false);
                Toast.fire({
                    icon: "error",
                    title: "Invalid Input",
                });
            }
        }
    }, [saveLeavesSlice.data]);

    return (
        <ModalComponent
            setShowModal={setShowModal}
            showModal={showModal}
            maxWidth="sm"
        >
            <MDBox pb={3} sx={{ padding: { xs: 2, md: 6 }, paddingTop: { xs: 6 } }}>
                <Grid container spacing={2}>
                    {leaveSummary.map((type) => (
                        <Grid item xs={12} sm={4} key={type}>
                            <MDBox
                                p={2}
                                border="1px solid #ccc"
                                borderRadius="10px"
                                textAlign="center"
                            >
                                <strong>{type.label}</strong>
                                <div>{type.count} Days</div>
                            </MDBox>
                        </Grid>
                    ))}
                </Grid>
                <Grid container spacing={3} mt={2}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            type="date"
                            label="Start Date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            type="number"
                            label="No of Days"
                            value={noOfDays}
                            onChange={(e) =>
                                setNoOfDays(e.target.value.replace(/[^0-9]/g, ""))
                            }
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CommonSelect
                            label="Reason"
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            options={reasonOptions}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CommonSelect
                            label="Leave Type"
                            value={leaveType}
                            onChange={(e) => setLeaveType(e.target.value)}
                            options={typeOptions}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <MDButton
                            variant="gradient"
                            color="info"
                            fullWidth
                            disabled={
                                !startDate || !noOfDays || !reason || !leaveType
                            }
                            onClick={handleSubmit}
                        >
                            Submit Leave
                        </MDButton>
                    </Grid>
                </Grid>
                <MDBox mt={3}>
                    <h4>Leave Records</h4>
                    <Grid container spacing={2}>
                        {leaveData.map((leave) => (
                            <Grid item xs={12} key={leave.leave_id}>
                                <MDBox
                                    p={2}
                                    border="1px solid #ddd"
                                    borderRadius="10px"
                                >
                                    <div><strong>Type:</strong> {leave.type}</div>
                                    <div><strong>Days:</strong> {leave.no_of_days}</div>
                                    <div><strong>Reason:</strong> {leave.reason}</div>
                                    <div><strong>Start Date:</strong> {leave.start_date}</div>
                                </MDBox>
                            </Grid>
                        ))}
                    </Grid>
                </MDBox>
            </MDBox>
        </ModalComponent>
    );
};

export default EmployeeLeaveModel;
